/**
 * @module convertTimesArrayToString
 */

/**
 * @function
 * To convert time array to a string
 * @param {any[]} renderingTimes - An array of times
 * @returns A string of times
 */

const convertTimesArrayToString = (renderingTimes: any[]) => {
    let returnString = '[';
    Object.keys(renderingTimes).forEach((element, index) => {
        if (index !== 0) {
            returnString += ', ';
        }
        returnString += `"${element}": "${renderingTimes[element]}"`;
    });
    returnString += ']';

    return returnString;
};

export default convertTimesArrayToString;
